module.exports = __webpack_public_path__ + "img/image-2.6dbf013d.jpg";